
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class WorkflowInstanceDocumentDialog extends SiteEntityDialog<WorkflowInstanceDocumentRow, any> {
        protected getFormKey() { return WorkflowInstanceDocumentForm.formKey; }
        protected getIdProperty() { return WorkflowInstanceDocumentRow.idProperty; }
        protected getLocalTextPrefix() { return WorkflowInstanceDocumentRow.localTextPrefix; }
        protected getNameProperty() { return WorkflowInstanceDocumentRow.nameProperty; }
        protected getService() { return WorkflowInstanceDocumentService.baseUrl; }

        protected form = new WorkflowInstanceDocumentForm(this.idPrefix);

        protected updateInterface() {
            super.updateInterface();

            if (this.isEditMode() && (this.entity.DocumentGroup || "").toLowerCase() != "upload") {
                this.toolbar.findButton('edit-button').hide();
            }

            this.cloneButton.hide();
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            WorkflowInstanceDocumentDialog.fixDocumentStoreThumb(this.form.DocumentId,
                this.entity.DocumentId, this.entity.DocumentName, this.entity.DocumentVersion);
        }

        static fixDocumentStoreThumb(upload: Serenity.ImageUploadEditor, documentId: string, documentName: string, documentVersion: number): void {
            if (documentId &&
                documentName &&
                Serenity.UploadHelper.hasImageExtension(documentName)) {
                var ext = documentName.substr(documentName.lastIndexOf('.'));
                Serenity.UploadHelper.populateFileSymbols(upload.element.find('ul'),
                    [{ Filename: documentId + ext }], false);
            }

            if (documentId) {
                var version = ((documentVersion) || '0').toString();
                var fi = upload.element.find('li.file-item');
                var a = fi.children('a');
                a.attr('href', a.attr('href') + '?v' + version);
                if (fi.hasClass('file-image') && a.hasClass('thumb')) {
                    a.css('background-image', 'url(' + a.attr('href'));
                }
            }
        }
    }
}